<template>
    <div class="login-box">
    </div>
</template>
 
<script>
export default {
    name: "Login",
    data() {
        return {
			
        };
    },
	created () {
		this.$navto('/home/index');
	},
};
</script>